/**
 * SectionHeader — section/card title row (Triveny TvLabel equivalent).
 *
 * Inter Tight 14 / 600 / -0.01em, optional description and right-aligned
 * action. Use inside PageContainer between cards, or as a card header row.
 */
import React from 'react'

interface SectionHeaderProps {
  title: React.ReactNode
  description?: React.ReactNode
  /** Right-aligned action (button/link). */
  action?: React.ReactNode
  className?: string
}

export function SectionHeader({ title, description, action, className = '' }: SectionHeaderProps) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="min-w-0">
        <h2 className="truncate font-display text-sm font-semibold tracking-[-0.01em] text-ink">
          {title}
        </h2>
        {description !== undefined && (
          <p className="mt-0.5 text-[13px] text-ink-500">{description}</p>
        )}
      </div>
      {action && (
        <>
          <div className="flex-1" />
          <div className="flex items-center gap-2">{action}</div>
        </>
      )}
    </div>
  )
}
